// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupPermissionManagement_main__MlbZw {
    width: 100%;
    height: 100%;
}

.GroupPermissionManagement_header__uK6gC {
    height: 35px;
    margin-bottom: 25px;
}

.GroupPermissionManagement_title__1l8He {
    font-size: 30px;
}

.GroupPermissionManagement_container__CkleN {
    width: 100%;
    min-height: calc(100% - 60px);
    padding: 20px;
    border-radius: 6px;
    background-color: #ffffff;
}

.GroupPermissionManagement_add_box__iidFR {
    width: 100%;
    height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/GroupPermissionManagement/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n}\n\n.header {\n    height: 35px;\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n\n.container {\n    width: 100%;\n    min-height: calc(100% - 60px);\n    padding: 20px;\n    border-radius: 6px;\n    background-color: #ffffff;\n}\n\n.add_box {\n    width: 100%;\n    height: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `GroupPermissionManagement_main__MlbZw`,
	"header": `GroupPermissionManagement_header__uK6gC`,
	"title": `GroupPermissionManagement_title__1l8He`,
	"container": `GroupPermissionManagement_container__CkleN`,
	"add_box": `GroupPermissionManagement_add_box__iidFR`
};
export default ___CSS_LOADER_EXPORT___;
